import React, { useMemo } from 'react';
import { useFormikContext, FieldArray } from 'formik';
import { useGridApiRef } from '@mui/x-data-grid-premium';
import { Box, Paper, Typography } from '@mui/material';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers } from '../../Interface';
import { CheckboxUI, DatagridPremiumUi } from '../../Interface';

const AlertFormUsersTable = (props) => {
  const { users } = props;
  const apiRef = useGridApiRef();

  const { values } = useFormikContext();

  const columns = useMemo(
    () => (remove, push) =>
      dataGridPremiumColumns([
        {
          field: 'nickName',
          headerName: 'Felhasználó',
          type: 'string',
        },
        {
          field: 'userName',
          headerName: 'Felhasználónév',
          type: 'string',
        },
        {
          field: 'quantWarn',
          headerName: 'Quant',
          type: 'boolean',
          sortable: false,
          valueGetter: (_val, row) => {
            const alertRecipient = values.alertRecipient.find((ar) => ar.userId === row.userId);

            return Boolean(alertRecipient);
          },
          renderCell: (data) => (
            <CheckboxUI
              name={`alertRecipient_${data.row.userId}`}
              checked={Boolean(values.alertRecipient.find((ar) => ar.userId === data.row.userId))}
              variant="standard"
              size="small"
              sx={{
                p: 0.25,
                '& .MuiSvgIcon-root': {
                  fontSize: 18,
                },
              }}
              onChange={(e) => {
                const findedVal = values.alertRecipient.find((ar) => ar.userId === data.row.userId);
                if (e.target.checked && !findedVal) {
                  push({ userId: data.row.userId });
                } else if (!e.target.checked && findedVal) {
                  const index = values.alertRecipient.findIndex((ar) => ar.userId === data.row.userId);
                  remove(index);
                }
              }}
            />
          ),
        },
      ]),
    [users, values.alertRecipient]
  );

  return (
    <Box sx={{ overflowX: 'auto' }} pt={1}>
      <Paper
        elevation={1}
        sx={{
          overflow: 'hidden',
          borderRadius: { xs: 1, sm: 2 },
        }}
      >
        <Typography variant="body2" color="text.secondary" fontWeight={600} fontSize={'1rem'} my={1}>
          Felhasználók
        </Typography>
        <FieldArray name="alertRecipient">
          {({ remove, push }) => (
            <DatagridPremiumUi
              apiRef={apiRef}
              datagridIdentifier={DataGridIdentifiers.AlertRecipient}
              height={660}
              columns={columns(remove, push)}
              rows={users}
              rowCount={users.length}
              onCellDoubleClick={(_params, event) => {
                event.defaultMuiPrevented = true;
              }}
              getRowHeight={() => 'auto'}
              getRowId={(row) => row.userId}
            />
          )}
        </FieldArray>
      </Paper>
    </Box>
  );
};

export default AlertFormUsersTable;
